"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrimSpacingVertical = exports.scrimSpacingHorizontal = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css2 = require("@emotion/css");
var _closeSmall = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/close-small"));
var _elevation = require("@amzn/meridian-tokens/base/elevation");
var _modalFooter = _interopRequireDefault(require("./modal-footer"));
var _button = _interopRequireDefault(require("../button"));
var _icon = _interopRequireDefault(require("../icon"));
var _theme = _interopRequireDefault(require("../theme"));
var _focusTrap = _interopRequireDefault(require("../_focus-trap"));
var _useUniqueId = _interopRequireDefault(require("../use-unique-id/use-unique-id"));
var _propTypes2 = _interopRequireDefault(require("./../_prop-types"));
var _isElementOf = _interopRequireDefault(require("./../_utils/is-element-of"));
var _useFocus2 = _interopRequireDefault(require("../_use-focus"));
var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));
var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));
var _getInlinePadding = _interopRequireDefault(require("./../_utils/get-inline-padding"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var closeButtonWidth = 32; // px
var scrimSpacingVertical = 10; // vh
exports.scrimSpacingVertical = scrimSpacingVertical;
var scrimSpacingHorizontal = 10; //vw
exports.scrimSpacingHorizontal = scrimSpacingHorizontal;
var isFooter = (0, _isElementOf["default"])(_modalFooter["default"]);
var isNotFooter = function isNotFooter(child) {
  return !isFooter(child);
};
var styles = function styles(t, _ref) {
  var focus = _ref.focus,
    scrollContainer = _ref.scrollContainer,
    fullscreen = _ref.fullscreen,
    width = _ref.width,
    bodySpacingInset = _ref.bodySpacingInset,
    showTitle = _ref.showTitle,
    showCloseButton = _ref.showCloseButton;
  var padding = (0, _getInlinePadding["default"])(bodySpacingInset);
  return (0, _css2.css)(
  /**
   * Focus ring styles - important that these are first so subsequent styles
   * (like `position: fixed` for fullscreen modals) can overwrite the ring styles.
   */
  focus ? (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderRadius: t("borderRadius")
  }) : {},
  /**
   * Fullscreen vs non-fullscreen styles
   */
  fullscreen ? {
    // Fullscreen modals aren't shown in a scrim so we've got to handle
    // layout here
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: _elevation.elevationModal,
    // Use momentum scrolling on iOS. See:
    // https://css-tricks.com/snippets/css/momentum-scrolling-on-ios-overflow-elements/
    overflowY: "scroll",
    WebkitOverflowScrolling: "touch"
  } : {
    // Apply the user-provided width if we're not showing a fullscreen
    // modal
    width: width,
    // This allows the absolutely-positioned close button to anchor itself
    // to the modal
    position: "relative",
    boxShadow: t.boxShadowCss("dropShadow"),
    maxHeight: scrollContainer === "modal" ? "".concat(100 - scrimSpacingVertical * 2, "vh") : undefined,
    maxWidth: "".concat(100 - scrimSpacingHorizontal * 2, "vw"),
    borderRadius: t("borderRadius")
  }, {
    /**
     * Common styles
     */
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: t("bodyBackgroundColor"),
    outline: "none",
    /**
     * Header styles
     */
    "& > [mdn-modal-title]": (0, _css2.css)(_objectSpread({
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginTop: "0px",
      marginBottom: "0px",
      minHeight: t("headerMinHeight"),
      paddingTop: t("headerSpacingInsetTop"),
      paddingBottom: t("headerSpacingInsetBottom"),
      paddingInlineStart: t("headerSpacingInsetStart"),
      paddingInlineEnd: t("headerSpacingInsetEnd"),
      backgroundColor: t("headerBackgroundColor"),
      color: t("headerForegroundColor")
    }, t.typographyCss("header"))),
    /**
     * Body styles
     */
    "& > div:not([mdn-modal-footer])": {
      paddingInlineStart: padding.paddingInlineStart,
      paddingTop: padding.paddingTop,
      paddingBottom: padding.paddingBottom,
      // If there is no title bar but there is a close icon button,
      // add additional padding so that the body of the modal does
      // not overlap on top of the close icon button.
      paddingInlineEnd: showCloseButton && !showTitle ? "calc(".concat(padding.paddingInlineEnd, "px + ").concat(closeButtonWidth, "px)") : padding.paddingInlineEnd,
      overflowY: scrollContainer === "modal" ? "auto" : undefined,
      overflowX: "auto",
      // In fullscreen mode the body should fill up any screen space not used by
      // the header or footer
      flex: fullscreen ? "auto" : undefined
    },
    /**
     * Footer styles
     */
    "& > [mdn-modal-footer]": {
      borderTop: t.borderCss("footerBorder"),
      padding: t("footerSpacingInset"),
      overflow: "initial"
    }
  });
};
var closeButtonStyles = function closeButtonStyles(t) {
  var _css;
  return (0, _css2.css)((_css = {
    position: "absolute",
    top: t("closeButtonSpacingWebTop"),
    right: t("closeButtonSpacingWebEnd")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    left: t("closeButtonSpacingWebEnd"),
    right: "auto"
  }), (0, _defineProperty2["default"])(_css, "zIndex", _elevation.elevationForeground), _css));
};
var ModalTitle = function ModalTitle(_ref2) {
  var level = _ref2.level,
    children = _ref2.children,
    id = _ref2.id;
  var Tag = level ? "h".concat(level) : "h2";
  return /*#__PURE__*/_react["default"].createElement(Tag, {
    "mdn-modal-title": "",
    id: id
  }, children);
};

/* eslint-disable react/prop-types, react/display-name */
// The element we use at the root of the modal depends on
// the presence of an `onSubmit` prop. If the method
// is present, the modal uses a <form> element, else
// a <div>
var ModalBoxRoot = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(props.onSubmit ? "form" : "div", _objectSpread(_objectSpread({}, props), {}, {
    tabIndex: 0,
    ref: ref,
    role: "dialog"
  }));
});
/* eslint-enable react/prop-types, react/display-name */

/**
 * This component can be used to render a modal for your application
 */
var ModalBox = /*#__PURE__*/_react["default"].forwardRef(function (props, _) {
  var onClose = props.onClose,
    onSubmitForm = props.onSubmitForm,
    formAction = props.formAction,
    formMethod = props.formMethod;
  var id = (0, _useUniqueId["default"])({
    prefix: "modal-"
  });
  var headerId = props.title ? "".concat(id, "-header") : undefined;
  var footer = _react["default"].Children.toArray(props.children).filter(isFooter)[0];
  var _useFocus = (0, _useFocus2["default"])(props),
    focus = _useFocus.focus,
    focusTrigger = _useFocus.focusTrigger,
    focusProps = _useFocus.focusProps,
    focusDescendent = _useFocus.focusDescendent;
  var modalRef = /*#__PURE__*/(0, _react.createRef)();

  // Call the onClose handler if the esc key is pressed
  var onKeyDownDocument = (0, _react.useCallback)(function (event) {
    if (event.key === "Escape") {
      onClose();
    }
  }, [onClose]);
  (0, _react.useEffect)(function () {
    if (modalRef.current) {
      var _modalRef$current;
      // Get the active element and check if it's inside of the modal
      var activeElementInsideModal = (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 ? void 0 : _modalRef$current.contains(document.activeElement);
      if (modalRef.current && !activeElementInsideModal) {
        // Focus the first node in the Modal
        modalRef.current.focus({
          preventScroll: true
        });
      }
    }
    // Note: we disable exhaustive deps because refs (modalRef)
    // is not a valid dependency anyways for useEffect. We are guaranteed
    // to have the modalRef at time of render, so this triggers only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Bind the onKeyDownDocument handler to the window
  (0, _react.useEffect)(function () {
    if (onClose) {
      window.addEventListener("keydown", onKeyDownDocument);
    }
    return function () {
      return window.removeEventListener("keydown", onKeyDownDocument);
    };
  }, [onClose, onKeyDownDocument]);
  var onSubmit = (0, _react.useCallback)(function (event) {
    if (!formAction && !formMethod) event.preventDefault();
    onSubmitForm();
  }, [formAction, formMethod, onSubmitForm]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(_focusTrap["default"], {
    focusRef: modalRef
  }, /*#__PURE__*/_react["default"].createElement(ModalBoxRoot, (0, _extends2["default"])({}, focusProps, {
    className: (0, _css2.cx)(props.className, styles(props.t, {
      focus: focus && focusTrigger === "keyboard" && !focusDescendent,
      scrollContainer: props.scrollContainer,
      width: props.width,
      fullscreen: props.fullscreen,
      bodySpacingInset: props.bodySpacingInset,
      showTitle: Boolean(props.title),
      showCloseButton: Boolean(onClose)
    })),
    onTransitionEnd: props.onTransitionEnd,
    onSubmit: onSubmitForm ? onSubmit : undefined,
    action: props.formAction,
    method: props.formMethod,
    "aria-labelledby": headerId,
    "aria-modal": true,
    ref: modalRef
  }, passThroughProps), props.title ? /*#__PURE__*/_react["default"].createElement(ModalTitle, {
    id: headerId,
    level: props.titleLevel
  }, props.title) : null, onClose ? /*#__PURE__*/_react["default"].createElement(_theme["default"], {
    mode: props.title ? "dark" : null
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    onClick: onClose,
    size: "small",
    type: "icon",
    className: closeButtonStyles(props.t),
    propagateClickEvent: props.closeButtonPropagateClickEvent
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _closeSmall["default"]
  }, props.closeLabel))) : null, /*#__PURE__*/_react["default"].createElement("div", null, _react["default"].Children.toArray(props.children).filter(isNotFooter)), footer ? footer : null));
});
ModalBox.displayName = "ModalBox";
ModalBox.propTypes = process.env.NODE_ENV !== "production" ? {
  closeLabel: _propTypes["default"].string.isRequired,
  bodySpacingInset: _propTypes2["default"].spacing(4),
  children: _propTypes["default"].node,
  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,
  closeButtonPropagateClickEvent: _propTypes["default"].bool,
  formAction: _propTypes["default"].string,
  formMethod: _propTypes["default"].oneOf(["get", "post", "dialog"]),
  fullscreen: _propTypes["default"].bool,
  scrollContainer: _propTypes["default"].oneOf(["modal", "viewport"]),
  t: _propTypes["default"].func,
  title: _propTypes["default"].string,
  /**
   * The title heading level. This corresponds directly to the [6 HTML headings](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Heading_Elements)
   * and, if set, will render the Modal title in a heading component. For example,
   * setting `titleLevel={3}` will render the Modal title in an `<h3>` element.
   *
   * You should chose a level based on the Modals markup position and the documents
   * current heading structure ([lean more](https://www.w3.org/TR/2016/REC-html51-20161101/sections.html#headings-and-sections)). This will make it easier for
   * screen reader users to quickly make sense of the page's structure.
   *
   * For example, if the Modal is intended for the entire page, a `titleLevel={1}`
   * could be warranted. If the Modal is only relevant to a particular section
   * that was titled with a `<Heading level={3}/>`, a `titleLevel={3}` would be
   * a better choice.
   *
   * Because we cannot safely presume the heading structure of your page we do not
   * set a default value. If `titleLevel` is left unset, the title will render
   * in a `<h2>` element.
   */
  titleLevel: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]),
  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onClose: _propTypes["default"].func,
  onSubmitForm: _propTypes["default"].func,
  onTransitionEnd: _propTypes["default"].func
} : {};
ModalTitle.propTypes = process.env.NODE_ENV !== "production" ? {
  children: ModalBox.propTypes.title,
  id: _propTypes["default"].string,
  level: ModalBox.propTypes.titleLevel
} : {};
var _default = ModalBox;
exports["default"] = _default;